import React from 'react';
import styled from 'styled-components';

const CapitalGains = ({data}) => {

    const curFormat = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const typeArr = [];
    data.types.map((type) => {
        return typeArr.push(type);
    });

    return (
        <CapitalGainsStyled className='CapitalGains'>
            <h3><strong>Capital Gains Tax Brackets</strong></h3>
            <div className='table-responsive-sm'>
                <table className='table table-bordered'>
                    <thead>
                        <tr key='header'>
                            {
                                data.column_headers.map((data, idx) => {
                                    return <th key={ idx }>{data}</th>
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.data.map((cellData, idx) => {
                                return <tr key={ idx } className={ idx }>{
                                    cellData.map((data, idx) => {
                                        typeArr[idx] === "currency" && curFormat.format(data) !== '$NaN' ? data = curFormat.format(data) :
                                        typeArr[idx] === "percent" ? data = data + "%" : data;
                                        return <td key={idx}>{data}</td>
                                    })
                                }</tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
        </CapitalGainsStyled>
    );
}

export default CapitalGains;

const CapitalGainsStyled = styled.div`
    margin-bottom: 15px;
    table {
        th {
            min-width: 150px;
        }
        thead {
            tr {
                border-bottom: 1px solid #ddd;
            }
            th {
                border-right: 1px solid #ddd;
                :last-child{
                    border-right: none;
                }
            }
        }
        tbody {
            tr {
                border-bottom: 1px solid #ddd;
                :last-child{
                    border-bottom: none;
                }
            }
            td {
                border-right: 1px solid #ddd;
                :last-child{
                    border-right: none;
                }
            }
        }
    }
`;